var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStatusActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfx_iconStatusActive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gfx_iconStatusActive",
    fill: "#0CA900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0728535,66 L99.0728535,66 C102.938847,66 106.072853,69.1340068 106.072853,73 L106.072853,85 C106.072853,88.8659932 102.938847,92 99.0728535,92 L57.0728535,92 L45.0728535,92 C41.2068602,92 38.0728535,88.8659932 38.0728535,85 L38.0728535,48 C38.0728535,44.1340068 41.2068602,41 45.0728535,41 L57.0728535,41 C60.9388467,41 64.0728535,44.1340068 64.0728535,48 L64.0728535,66 Z",
    id: "Combined-Shape",
    transform: "translate(72.072853, 66.500000) rotate(-45.000000) translate(-72.072853, -66.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 Z M72,122 C99.6142375,122 122,99.6142375 122,72 C122,44.3857625 99.6142375,22 72,22 C44.3857625,22 22,44.3857625 22,72 C22,99.6142375 44.3857625,122 72,122 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusActive);
export default __webpack_public_path__ + "static/media/iconStatusActive.7ba55c94ca35c70e693a83ec6d08ac50.svg";
export { ForwardRef as ReactComponent };